<app-monitor-layout #monitorContainer
  [test]="test"
  [testLoading]="testLoading$ | async"
  [patient]="patient"
  [bundle]="bundle"
  [screen]="currentDeviceScreen"
  [isTestDone]="isTestDone"
  [isTestSyncing]="isTestSyncing"
  [deviceLoading]="deviceLoading$ | async"
  [device]="device"
  [batteryPercentage]="batteryPercentage"
  [streamPopupVisible]="streamPopupVisible"
  [isSingleImage]="isSingleImage"
  [isV2Streaming]="isV2Streaming"
  [deviceActionLoading]="deviceActionLoading"
  [isLoading]="isLoading"
  [headsetAlignment]="headsetAlignment"
  (onClose)="close()"
  (onStreamOpen)="openStream($event)"
  (onStreamClose)="closeStream()"
  (onActionClicked)="onActionClicked($event)">

  <div class="monitor_container-column monitor_container-column--limit-height">
    <div class="monitor_graph-box">
      @if (isTestSyncing) {
        <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
      }
      <div class="monitor_graph-title">{{ 'left' | translate | titlecase }}</div>
      <div @startList class="monitor_list-container">
        @for (record of leftEarRecords.slice().reverse(); track record; let i = $index) {
          <div
            @fadeAnimation
            class="monitor_list-item"
            [ngClass]="{'hidden': isLeftEarRecordHidden(record, i)}">
            @if (record) {
              <ng-container *ngTemplateOutlet="recordView; context: { record: record }"></ng-container>
            } @else {
              <span class="text--blink">{{'syncing' | translate | titlecase}}...</span>
            }
          </div>
        }
        @if (!isLoading && !leftEarRecords?.length) {
          <small>{{ isTestDone ? ('noTestDataReceived' | translate) : ('noTestData' | translate) }}</small>
        }
      </div>
    </div>
    <div class="monitor_graph-box">
      @if (isTestSyncing) {
        <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
      }
      <div class="monitor_graph-title">{{ 'right' | translate | titlecase }}</div>
      <div @startList class="monitor_list-container">
        @for (record of rightEarRecords.slice().reverse(); track record; let i = $index) {
          <div
            @fadeAnimation
            class="monitor_list-item"
            [ngClass]="{'hidden': isRightEarRecordHidden(record, i)}">
            @if (record) {
              <ng-container *ngTemplateOutlet="recordView; context: { record: record }"></ng-container>
            } @else {
              <span class="text--blink">{{'syncing' | translate | titlecase}}...</span>
            }
          </div>
        }
        @if (!isLoading && !rightEarRecords?.length) {
          <small>{{ isTestDone ? ('noTestDataReceived' | translate) : ('noTestData' | translate) }}</small>
        }
      </div>
    </div>
  </div>

  <div class="monitor_container-column">
    <div class="monitor_graph-box monitor_graph-box--single">
      @if (isTestSyncing) {
        <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
      }
      <app-percentage-circle
        id="test-percentage"
        class="monitor_circle-box"
        [percentage]="getPercentageDone()">
      </app-percentage-circle>
    </div>
  </div>
</app-monitor-layout>

<ng-template #recordView let-record="record">
  <i
    class="fas fa-headphones"
    [ngClass]="{ 
        'orange': !record?.is_heard || record.response_time < 0.15, 
        'color-primary': record?.is_heard && record.response_time > 0.15
      }"></i>
  <span
    matTooltip="{{ 'frequency' | translate | titlecase }}"
    class="pointer">
    {{ record.frequency + ' hZ' }}
  </span>

  <span class="pointer" matTooltip="{{ 'volume' | translate | titlecase }}">
    {{ record.volume_db + ' dB' }}
  </span>

  <span
    [ngClass]="{ 
    'orange': !record?.is_heard || record.response_time < 0.15, 
    'color-primary': record?.is_heard && record.response_time > 0.15
    }">
    {{ (record?.is_heard && record.response_time > 0.15) ? ('heard' | translate | titlecase) : ('unheard' | translate | titlecase) }}
  </span>
</ng-template>

